export const HIDDEN_FEATURES = [
  // ── Course Standards ──────────────────────────────────────────────────────
  'CMI-5',
  'SCORM 2004, 3rd edition',

  // ── Legacy top-level categories ───────────────────────────────────────────
  'PENS',
  'Deep Learning',
  'Coaching',
  'Microsoft Teams Integration',
  'Knowledge reinforcement tool',
  'Ad-hoc',
  'Single Sign On',
  'HRIS/ERP/Salesforce/Sharepoint/Other integration(s)',
  'Administrator',
  'Competency/Skill Management',
  'Compliance Management',
  'Content Curation',
  'Curation',
  'E-Commerce',
  'E-Learning Marketplace',
  'Learning Environment',
  'Learning Record Store (LRS)',
  'Playlists',
  'Reporting and Analytics',
  'Skill Ratings',
  'Security',
  'Social',
  'Upload 3rd party authoring tool (ex: Articulate Storyline, Captivate, dominKnow, etc.)',
  'Video Management',
  'vILT',
  // Features from initial DB not in any CSV category
  'Built in assessment/survey tool',
  'Built-in authoring tool',
  'Certificates',
  'Event Management',
  'Gamification',
  'Modern UI/UX',
  'Notifications',
  // New categories not in CSV
  'Mentoring',
  'Integrations',
  'Mobile',
  'Cohort-based Learning',
  'App Exchange Marketplace',
  'Languages',
  'Multi-Tenant/Extended Enterprise',
  'Physical Training - ILT',

  // ── Coaching children (all hidden) ────────────────────────────────────────
  'Coach / mentor can communicate with the learner via web cam or other solution within the system',
  'Mobile coaching capabilities within an app',
  'Learner can select from a group of "experts" within the system',
  'Coaches\'s expertise is visible on their profiles within the system',

  // ── Mentoring children (parent merged into Coaching/Mentoring) ────────────
  'Ability to view "mentors" profile in the system',
  'Ability to select a mentor or have one assigned, regardless per learner or multiple communities/pods',
  'Mentor Profile includes information about mentor, expertise skills/topics, etc.',
  'Learner can leave either a rating or "thumbs up"',

  // ── Curation children ─────────────────────────────────────────────────────
  'System offers contextual actions',
  'Learner can share any content, including video, audio, etc.with a single learner, multiple learners, shared groups or in an area or section designated for curation',
  'Learners can leave comments, make suggestions, rank/ rate(if available) any content',
  'Manager can accept or decline various curation capabilities',
  'Administrator can accept or decline various curation capabilities',
  'System scans the Internet and brings in content that is tied to the learner\'s interest, job role and/or skill(s)',

  // ── Playlists children ────────────────────────────────────────────────────
  'The learner can create their own content playlist and share it with others',
  'System can generate a playlist based on skill rating, skill level or any other skill related variable',
  'Trending or most popular playlist',
  'Recommend content playlist',
  'Learner\'s interests or topics playlist',
  'Assigned learning playlist',
  'A learner can create multiple playlists',
  'Manager can create a learner\'s playlist',
  'Ability to add Podcasts to playlist',
  'Learner can view playlists by skill(s)',
  'Learner can view playlist by job role',

  // ── AI children (old/replaced entries) ───────────────────────────────────
  'Can scan documents, courses, content, audio and video files and produce results',
  'If a learner does not complete a piece of content, the algorithm will still produce similar results to those if the learner did complete the content.',
  'System can use job roles and / or skills to identify and present recommended or suggested content',
  'Can create a learning path based upon recommendations',
  'Recommends courses based on previous courses in-progress/completed',

  // ── General children not in CSV ───────────────────────────────────────────
  'Video streaming',
  'Change labels/Text',
  'Change colors, Add Logo (on the admin side)',
  'Open REST API',
  'GDPR Compliant',
  'Self-registration',
  'Create a new password, if they forget current password',
  'Custom Domain',
  'SSO (Single-Sign On)',
  'Active Directory/LDAP',

  // ── Integrations children ─────────────────────────────────────────────────
  'Workday',
  'Oracle',
  'Salesforce',
  'Business Intelligence',
  'Other HRIS/HCM Platform',
  'Microsoft Teams',
  'Slack',
  'SharePoint',
  'Other Platforms',

  // ── Learning Environment children not moved to Learning Options ───────────
  'Attach CEU/CPD to any content',
  'Learner Transcript or Progress Circle/Bar',
  'Learning Journeys',
  'Synchronous-Based Learning',

  // ── Reporting and Analytics children ─────────────────────────────────────
  'Data Visualization',
  'Ad - Hoc Reporting',
  'Analytics include not only content within the platform, but also web site links, articles posted on the net, eBooks, etc.',
  'Can create KPIs and / or Heat maps',
  'Business Intelligence integration',

  // ── Skills children not in CSV ────────────────────────────────────────────
  'Import skill dictionaries and job definitions and link definitions to competencies',
  'Create your own library of skills, including definitions',
  'Allow learners to self - assess their existing skills',
  'Manager / Administrator can edit or change skill learner\'s rating',
  'Skills tied to job roles / job profiles, which can be used to submit to jobs within the company',
  'Create your own Skills Taxonomy',
  'Learner can select more than one skill',
  'Skills can be tied to content or learning journey or opportunity',
  'Skill metrics (on Admin dashboard)',
  'Skill(s) can be tied to one or multiple job roles',
  'Ability to assign content based upon skills needed/required for job role',

  // ── Multi-Tenant/Extended Enterprise children ─────────────────────────────
  'Ability to brand and skin each tenant/portal',
  'Ability to assign specific rules to each tenant/portal',
  'Ability to view metrics/reporting for each tenant',
  'Ability to have as many tenants/portals as you want',
  'Ability to create custom domains',
  'Ability to skin/brand each tenant/portal',

  // ── Cohort-based Learning children ───────────────────────────────────────
  'Create as many communities/learning pods as you want',
  'Ability to limit the number of learners in each community',
  'Ability to have multiple guided learning sessions, at any given time',
  'Ability to have multiple facilitators/guides per session',
  'Ability for cohorts to share any type of content with other cohort members',
  'Cohort-based learning metrics (viewed on Admin dashboard)',

  // ── vILT children ─────────────────────────────────────────────────────────
  'Web-conferencing integration',
  'Schedule Virtual Learning Training Sessions',

  // ── Social children ───────────────────────────────────────────────────────
  'List Interests, Skills and other information as part of your Profile',

  // ── Video Management children ─────────────────────────────────────────────
  'Ability to add a quiz/assessment to a video (within the video)',
  'Auto detect Frames per second and view',

  // ── Administrator children ────────────────────────────────────────────────
  'Batch upload of learners',
]
